import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import {
	VaunceAppCMTTicketOnPosType,
	VaunceAppMUTTicketOnPosType,
	VaunceAppOTTTicketOnPosType,
	VaunceAppPKGTicketOnPosType,
	VaunceAppTicketOnPosHistoryType,
	VaunceAppTicketOnPosType,
	VaunceAppV2AppTicketType,
	VaunceCouponInfoType,
} from '@kinderlabs-pos/shared-data-type';

export const search앱티켓과쿠폰 = (rootUrl: string) => {
	return async ({ search }: { search: string }) =>
		(
			await posAxiosClient.get<{
				idMatched: boolean;
				ottList?: VaunceAppOTTTicketOnPosType[];
				mutList?: VaunceAppMUTTicketOnPosType[];
				cmtList?: VaunceAppCMTTicketOnPosType[];
				pkgList?: VaunceAppPKGTicketOnPosType[];
				couponList?: VaunceCouponInfoType[];
			}>(`${rootUrl}/pos-bff/vaunce/app-ticket/search`, {
				params: {
					search,
				},
			})
		).data;
};
export const getAppTicketHistoryAsync = (rootUrl: string) => {
	return async ({
		ticketId,
		ticketType,
	}: {
		ticketId: string;
		ticketType: VaunceAppV2AppTicketType;
	}) =>
		(
			await posAxiosClient.get<VaunceAppTicketOnPosHistoryType[]>(
				`${rootUrl}/pos-bff/vaunce/app-ticket/history`,
				{
					params: {
						ticketId,
						ticketType,
					},
				}
			)
		).data;
};

export const getAppTicketForUserAsync = (rootUrl: string) => {
	return async ({ memberId }: { memberId: number }) =>
		(
			await posAxiosClient.get<VaunceAppTicketOnPosType[]>(
				`${rootUrl}/pos-bff/vaunce/app-ticket/search/all`,
				{
					params: {
						memberId,
					},
				}
			)
		).data;
};
